import { render, staticRenderFns } from "./ConsumeByOT.vue?vue&type=template&id=c667af5c&scoped=true&"
import script from "./ConsumeByOT.vue?vue&type=script&lang=js&"
export * from "./ConsumeByOT.vue?vue&type=script&lang=js&"
import style0 from "./ConsumeByOT.vue?vue&type=style&index=0&id=c667af5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c667af5c",
  null
  
)

export default component.exports